module.exports = __webpack_public_path__ + "static/media/floral-ornament-svgrepo-com.a94fe78f.svg";